<style lang="scss"></style>

<template>
  <div id="modal-op-coleta" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form @submit.prevent="salvar">
          <div class="modal-header">
            <h4 class="modal-title">COLETA DE ORDEM DE PRODUÇÃO - {{ numOP }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div class="row">
                <div class="form-group col-md-4" :class="{ 'has-error': $v.numero.$error }">
                  <label class="control-label">Número</label>
                  <input
                    type="text"
                    class="form-control underlined"
                    v-model.trim="$v.numero.$model"
                  />
                  <template v-if="$v.numero.$dirty">
                    <span
                      v-if="!$v.numero.required"
                      class="has-error lblerror lblerror"
                    >Campo obrigatório</span>
                  </template>
                </div>
                <div class="form-group col-md-4" :class="{ 'has-error': $v.responsavel.$error }">
                  <label class="control-label">Responsável</label>
                  <input
                    type="text"
                    class="form-control underlined"
                    v-model.trim="$v.responsavel.$model"
                  />
                  <template v-if="$v.responsavel.$dirty">
                    <span
                      v-if="!$v.responsavel.required"
                      class="has-error lblerror lblerror"
                    >Campo obrigatório</span>
                  </template>
                </div>
                <div class="form-group col-md-4" :class="{ 'has-error': $v.data.$error }">
                  <label class="control-label">Data de Coleta</label>
                  <vc-date-picker
                    v-model.trim="$v.data.$model"
                    locale="pt-BR"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                  >
                    <input
                      type="tel"
                      v-mask="'##/##/####'"
                      class="form-control underlined"
                      slot-scope="{ inputProps, inputEvents }"
                      v-bind="inputProps"
                      v-on="inputEvents"
                    />
                  </vc-date-picker>
                  <template v-if="$v.data.$dirty">
                    <span
                      v-if="!$v.data.required"
                      class="has-error lblerror lblerror"
                    >Campo obrigatório</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="enviando"
            >{{ enviando ? "SALVANDO..." : "SALVAR" }}</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { showLoading, closeLoading } from '../../helpers';

import OrdemProducaoService from '../../services/OrdemProducaoService';

export default {
  name: 'modal-op-coleta',
  data() {
    return {
      enviando: false,
      numOP: null,
      ordemProducaoId: 0,
      numero: '',
      responsavel: '',
      data: '',
    };
  },
  validations: {
    numero: {
      required,
    },
    responsavel: {
      required,
    },
    data: {
      required,
    },
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-op-coleta').on('hidden.bs.modal', () => {
      this.$parent.coletaOrdemProducaoId = null;
    });

    if (this.$parent.coletaOrdemProducaoId === null) return;

    this.load();
  },
  methods: {
    async load() {
      try {
        showLoading();

        if (this.$parent.coletaOrdemProducaoId === 0) return;

        const {
          coleta,
          ...ordemProducao
        } = await OrdemProducaoService.findById(
          this.$parent.coletaOrdemProducaoId,
        );

        this.ordemProducaoId = ordemProducao.opId;
        this.numOP = ordemProducao.numOP;

        if (coleta.coletada) {
          this.numero = coleta.num;
          this.data = moment(coleta.data, 'DD/MM/YYYY').toDate();
          this.responsavel = coleta.responsavel;
        }
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-op-coleta').modal('show');
      }
    },
    async salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.info(
          'Por favor, verifique se todos os campos foi preenchido corretamente!',
        );
        return;
      }

      try {
        this.enviando = true;

        showLoading();

        const coleta = {
          numero: this.numero,
          data: moment(this.data, 'DD/MM/YYYY').toJSON(),
          responsavel: this.responsavel,
        };

        await OrdemProducaoService.collect(this.ordemProducaoId, coleta);

        this.$toast.success(
          'Dados de coleta da ordem de produção salva com sucesso!',
        );

        // eslint-disable-next-line
        $('#modal-op-coleta').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();
        this.enviando = false;
      }
    },
  },
};
</script>
